import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { savingNodesPositions } from '../actions/scrolling';
import Icon from '../assets/images/logo/treesome-logo.svg';
import Gallery from '../components/Gallery';
import Header from '../components/Header';
import Footer from '../components/Footer';
import NavigationBar from '../components/NavigationBar';
import Contact from '../components/Contact';
import AboutTreesome from '../components/treesome/AboutTreesome';
import Events from '../components/Events';
import PerformingTreesome from '../components/treesome/PerformingTreesome';
import { ChooseGroupSlug } from '../actions/SlugAction';
import { getEventsBySlug } from '../actions/EventsAction';
import { getGallery } from '../actions/GallerieAction';
import { getDairiesBySlug } from '../actions/DairiesAction';

const HeaderContent = (
  <div className="pt-3 pb-3">
    <img
      className="treesome-header-logo mt-5 mb-5"
      src={Icon}
      style={{
        width: 250,
      }}
    />
  </div>
);

class Treesome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menus: [],
      images: [],
      items: [],
      dairies: [],
    };
  }

  componentDidMount() {
    this.props.getGallery('treesomesousse');
    this.props.getEventsBySlug('treesomesousse');
    this.props.ChooseGroupSlug('treesomesousse');
    this.props.getDairiesBySlug('treesomesousse');
    const about = ReactDOM.findDOMNode(this.refs.about);
    const events = ReactDOM.findDOMNode(this.refs.events);
    const performing = ReactDOM.findDOMNode(this.refs.performing);
    const gallery = ReactDOM.findDOMNode(this.refs.gallery);

    this.props.savingNodesPositions({
      treesome: {
        about: about.offsetTop,
        events: events.offsetTop,
        performing: performing.offsetTop,
        gallery: gallery.offsetTop,
      },
    });
  }

  render() {
    return (
      <Fragment>
        <Header content={HeaderContent} background="treesome-header-bg">
          <NavigationBar
            slug="treesome"
            navigations={[
              { name: 'about', txt: 'About' },
              { name: 'events', txt: 'Events' },
              { name: 'performing', txt: 'Performing' },
              { name: 'gallery', txt: 'Gallery' },
            ]}
          />
        </Header>
        <AboutTreesome ref="about" background="treesome-about-bg" />
        <Events ref="events" background="treesome-event-bg" data={this.props.events} />
        <PerformingTreesome ref="performing" data={this.props.dairy} />
        <Gallery ref="gallery" background="treesome-gallery-bg" medias={this.props.gallerie} />
        <Contact ref="contact" minimal color="#128f24" placeholders="#004719" background="treesome-about-bg" info={info} />
        <Footer color="#128f24" secondColor="#004719" />
      </Fragment>
    );
  }
}

const info = {
  facebook: 'https://www.facebook.com/treesomesousse/',
  insta: 'https://www.instagram.com/the_treesome/',
  youtube: '',
  tripAdvisor: '',
  address: <span>SOCIETE " G A S " SARL 6ET, IMM "VENUS" A 6-4, Golf Advanced Services, 1082 CENTRE URB NORD</span>,
};

export default connect(
  store => ({
    scrolling: store.scrolling,
    gallerie: store.gallerie,
    events: store.events,
    dairy: store.dairy,
  }),
  {
    savingNodesPositions,
    ChooseGroupSlug,
    getEventsBySlug,
    getGallery,
    getDairiesBySlug,
  }
)(Treesome);



// WEBPACK FOOTER //
// ./src/pages/treesomesousse.jsx